export default {
  // 获取下拉数据
  getDataByKey(key) {
    return localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : null;
  },

  // 数据读取
  getMqConfig() {
    return JSON.parse(localStorage.getItem('MQCONFIG') || '{}')
  },
  getSessionID() {
    return localStorage.getItem('SESSIONID')
  },
  getUserName() {
    return localStorage.getItem('USERNAME')
  },
  getSysStaff() {
    return JSON.parse(localStorage.getItem('SYSSTAFF') || '{}')
  },
  getSysUser() {
    return JSON.parse(localStorage.getItem('SYSUSER') || '{}')
  },
  // 菜单
  getUserMenu() {
    return JSON.parse(localStorage.getItem('USERMENU') || '[]')
  },
  // 点击过的菜单
  getClickMenu() {
    let clickMenu = JSON.parse(localStorage.getItem('CLICKMENU') || '[]');
    return clickMenu;
  },
  getUserOperation() {
    return JSON.parse(localStorage.getItem('USEROPERATION') || '{}')
  },
  // 当前菜单
  getCurrentMune() {
    return JSON.parse(localStorage.getItem('CURRENTMENU') || '{}')
  },
  // 字典数据
  getCacheStatus(key) {
    let status = JSON.parse(localStorage.getItem('STATUSDATA') || '{}');
    let rtnStatus = status[key];
    let reg = /^(0|[1-9][0-9]*)$/;
    if (rtnStatus) {
      rtnStatus.map(item => {
        if (reg.test(item.value)) {
          item.value = parseInt(item.value);
          item.id = parseInt(item.id);
        }
      });
    }
    return rtnStatus || []
  },
  // 获取字典数据中的value
  getCacheStatusValue(key, id) {
    let status = JSON.parse(localStorage.getItem('STATUSDATA') || '{}');
    let rtnStatus = status[key];
    let reg = /^(0|[1-9][0-9]*)$/;
    let value;
    if (rtnStatus) {
      let valueFlag = true;
      rtnStatus.forEach(item => {
        if (valueFlag) {
          if (reg.test(item.value)) {
            item.id = parseInt(item.id);
            if (item.id === id) {
              value = item.label;
              valueFlag = false;
            }
          }
        }
      });
    }
    return value;
  },
  // 区域数据
  getAreaList() {
    return JSON.parse(localStorage.getItem('AREALIST') || '[]')
  },
  // 点击过的菜单
  setClickMenu(data) {
    localStorage.setItem('CLICKMENU', JSON.stringify(data))
  },
  // 区域数据
  setAreaList(data) {
    localStorage.setItem('AREALIST', JSON.stringify(data))
  },
  // 保存下拉数据
  setDataByKey(key, data) {
    localStorage.setItem(key, JSON.stringify(data))
  },

  // 数据保存
  setMqConfig(data) {
    localStorage.setItem('MQCONFIG', JSON.stringify(data))
  },
  setSessionID(data) {
    localStorage.setItem('SESSIONID', data)
  },
  setUserName(data) {
    localStorage.setItem('USERNAME', data)
  },
  setSysStaff(data) {
    localStorage.setItem('SYSSTAFF', JSON.stringify(data))
  },
  setSysUser(data) {
    localStorage.setItem('SYSUSER', JSON.stringify(data))
  },
  setUserMenu(data) {
    localStorage.setItem('USERMENU', JSON.stringify(data))
  },
  setUserOperation(data) {
    localStorage.setItem('USEROPERATION', JSON.stringify(data))
  },
  setCurrentMune(data) {
    localStorage.setItem('CURRENTMENU', JSON.stringify(data))
  },
  // 状态缓存
  setCache(data) {
    localStorage.setItem('STATUSDATA', JSON.stringify(data))
  },

  // 智能数据缓存
  setAnalysisData(data) {
    localStorage.setItem('ANALYSIS', JSON.stringify(data))
  },
  getAnalysisData() {
    return JSON.parse(localStorage.getItem('ANALYSIS') || '{}')
  },
  clearAnalysisData() {
    localStorage.removeItem('ANALYSIS');
  },
  // 处理级联数据childShow 是否默认展开
  dealCascadeData(data, parentId = 0, childShow = false, active = false) {
    let tree = [];
    data && data.forEach(item => {
      if (parentId === item.parentId) {
        const temp = this.dealCascadeData(data, item.id);
        let objectData = Object.assign({childShow, active}, item, {children: temp || []});
        if (objectData.operationList) {
          objectData.operationList.forEach(e => {
            objectData.children.push(Object.assign(e, {children: []}));
          });
        }
        tree.push(objectData);
      }
    });
    return tree;
  },
  // 移除
  clearUserName() {
    localStorage.removeItem('USERNAME');
  },

  // 获取cookie
  getCookie(key) {
    if (document.cookie.length > 0) {
      let start = document.cookie.indexOf(key + '=')
      if (start !== -1) {
        start = start + key.length + 1
        let end = document.cookie.indexOf(';', start)
        if (end === -1) end = document.cookie.length
        return unescape(document.cookie.substring(start, end))
      }
    }
    return ''
  },
  // 保存cookie
  setCookie(cName, value, expiredays) {
    let exdate = new Date()
    exdate.setDate(exdate.getDate() + expiredays)
    document.cookie = cName + '=' + decodeURIComponent(value) +
      ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
  },
  // 清除cookie
  removeCookie(cname) {
    let name = cname + '=';
    let ca = document.cookie.split(';');
    let cookieStr = '';
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(name) == 0) {
        document.cookie = c + ';expires=' + new Date(0).toUTCString()
      } else {
        cookieStr += c;
        cookieStr += ';';
      }
      document.cookie = cookieStr;
    }
  },
  // 轻量数据结构面包屑id、url、name is required of menu
  setBread(menu, that) {
    if (menu.url === that.$route.path) return;
    // 判断当前打开窗口数量是否超过8个。
    if (this.getClickMenu().length >= 8) {
      that.$message({
        message: '最多打开8个窗口，请关闭多余窗口',
        type: 'info'
      })
    }
    switch (menu.url) {
      case '/promotion/tilimitDiscount':
        break;
      case '/promotion/fullReduction':
        break;
      case '/promotion/fullDiscount':
        break;
      default:
        break;
    }

    let menuList = this.getClickMenu();
    menuList.map(item => {
      item.active = false;
    });

    let currentMenu = menuList.filter(item => {
      return item.id == menu.id
    });
    if (currentMenu.length == 0) {
      menu.active = true;
      menuList.push(menu);
    } else {
      currentMenu[0].active = true;
    }
    this.setClickMenu(menuList);
    that.$store.commit(this.storeKeys.CLICKMENU, menuList);

    that.$router.push({path: menu.url})
  },
  isRealNum(val) {
    if ('' === val || null == val) {
      return false;
    }
    if (!isNaN(val)) {
      return true;
    } else {
      return false;
    }
  },

// 获取excel表头
  getHeadData(columns, data) {
    let headArray = [];
    if (columns.length && columns.length > 0) {
      let columnsArray = this.cutArray(columns, 3);
      for (let i = 0; i < columnsArray.length; i++) {
        let objArray = [];
        for (let j = 0; j < columnsArray[i].length; j++) {
          let column = columnsArray[i][j];
          if (column.prop) {
            let obj = {label: column.label + '：', value: data[column.prop]};
            objArray.push(obj);
          }
        }
        headArray.push(objArray);
      }
    }
    return headArray;
  }
  ,

// 按照参数截取制定的集合
  cutArray(array, subLength) {
    let index = 0;
    let newArr = [];
    while (index < array.length) {
      newArr.push(array.slice(index, index += subLength));
    }
    return newArr;
  },

  clearDetailData(key) {
    localStorage.removeItem(key);
  }
}



// WEBPACK FOOTER //
// ./src/utils/dataCache.js